<template>
  <HomeComponent @updateTenant="updateTenant" />
</template>

<script>
  import HomeComponent from '../components/HomeComponent'

  export default {
    name: 'HomeView',

    components: {
      HomeComponent,
    },
    
    methods: {
      updateTenant(tenant) {
        this.$emit("updateTenant", tenant);
      }
    }
}
</script>
